var AvatarQueueBuilder = /** @class */ (function () {
    function AvatarQueueBuilder() {
        this.queue = {
            id: 'bboob0b0b0-boobob-21300321-0b0b0b',
            name: 'bob queue'
        };
    }
    AvatarQueueBuilder.prototype.withId = function (id) {
        this.queue.id = id;
        return this;
    };
    AvatarQueueBuilder.prototype.withName = function (name) {
        this.queue.name = name;
        return this;
    };
    AvatarQueueBuilder.prototype.build = function () {
        return this.queue;
    };
    return AvatarQueueBuilder;
}());
export { AvatarQueueBuilder };
//# sourceMappingURL=avatar-queue.js.map